<div class="sx-menu">
  @for(menuItem of menuItems; track menuItem.id; let i = $index;){
      
    @switch(menuItem.itemType){
      @case(itemTypeHeading){
        <!-- Heading -->
        <div class="sx-menu-item sx-menu-item-heading sxl-flex sxl-row sxl-justify-between sxl-items-center" id="{{menuItem.id}}">
          <h5 [innerHtml]="menuItem.displayText"></h5>
        </div>
      }
      @case(itemTypeFunction){
        <!-- Function -->
        <button mat-menu-item 
          class="sx-menu-item sxl-flex sxl-row" 
          id="{{menuItem.id}}" 
          (click)="callbackFunction( menuItem.callbackFunction )">
          @if(menuItem?.iconName){
            <mat-icon class="sx-menu-item__icon">
              <svg>
                <use [attr.xlink:href]="menuItem.iconName" [attr.href]="menuItem.iconName" />
              </svg>
            </mat-icon>
          }
          <span>{{ menuItem.displayText }}</span>
        </button>
      }
      @case(itemTypeLink){
        <!-- Link -->
        <button mat-menu-item 
          class="sx-menu-item sx-menu-item-blank sxl-flex sxl-row"
          [ngClass]="{'sx-menu-item__even-odd': evenOddRowStyle}" 
          id="{{menuItem.id}}"
          (click)="routeTo(menuItem.linkUrl)">
            <div class="truncate"  [ngClass]="{'sx-menu-item-active': menuItem.active}" [innerHtml]="menuItem.displayText"></div>
            @if(showTimestamps){
              <div class="sx-menu-item__timestamp">{{ menuItem.timestamp | outlookDate }}</div>
            }
        </button>
      }
      @case(itemTypeBlank){
        <!-- Blank -->
        <div mat-menu-item [ngClass]="{'sx-menu-item__even-odd': evenOddRowStyle}" class="sx-menu-item sx-menu-item-blank sxl-flex sxl-row" id="{{menuItem.id}}">
          <mat-icon class="sx-menu-item__icon">
            <svg>
              <use [attr.xlink:href]="menuItem.iconName" [attr.href]="menuItem.iconName" />
            </svg>
          </mat-icon>
          <div class="sx-menu-item__text truncate" [innerHtml]="menuItem.displayText"></div>
          @if(showTimestamps){
            <div class="sx-menu-item__timestamp">{{ menuItem.timestamp | outlookDate }}</div>
          }
        </div>
      }
      @case(itemTypeInfoText){
        <!-- Info text -->
        <div mat-menu-item class="sx-menu-item sx-menu-item__info-text truncate sxl-flex sxl-justify-center sx-message__item-title" id="{{menuItem.id}}">
          {{ menuItem.displayText }}
        </div>
      }
    }
  }
  @if(allItemsText && allItemsUrl){
    <!-- Read all -->
    <div mat-menu-item class="sx-menu-item__last sxl-flex sxl-justify-center">
      <span class="sx-menu-item__read-all" data-cy="menu-item-read-all" (click)="routeTo(allItemsUrl)" style="font-weight: bold;">
        {{ allItemsText }}
      </span>
    </div>
  }
</div>
